import { tv, type VariantProps } from "tailwind-variants"
import {
  type AvatarBadgeSize,
  avatarBadgeVariants,
} from "../Avatar/avatar-badge"
import { LOCKUP_SIZES } from "../Lockup/lockup-size-variants"

export type TableSize = NonNullable<
  VariantProps<typeof tableRowSizeVariants>["size"]
>

type TableSizeValues = {
  rowHeight: number
  image: number
  badge?: AvatarBadgeSize
  gap: number
}

export const TABLE_SIZES: Record<TableSize, TableSizeValues> = {
  xs: {
    rowHeight: 24,
    image: LOCKUP_SIZES.xs.image,
    badge: LOCKUP_SIZES.xs.badge,
    gap: 6,
  },
  sm: {
    rowHeight: 32,
    image: LOCKUP_SIZES.sm.image,
    badge: LOCKUP_SIZES.sm.badge,
    gap: 4,
  },
  md: {
    rowHeight: 48,
    image: LOCKUP_SIZES.md.image,
    badge: LOCKUP_SIZES.md.badge,
    gap: 4,
  },
  lg: {
    rowHeight: 60,
    image: LOCKUP_SIZES.lg.image,
    badge: LOCKUP_SIZES.lg.badge,
    gap: 4,
  },
  xl: {
    rowHeight: 68,
    image: LOCKUP_SIZES.xl.image,
    badge: LOCKUP_SIZES.xl.badge,
    gap: 4,
  },
  "2xl": {
    rowHeight: 76,
    image: LOCKUP_SIZES["2xl"].image,
    badge: LOCKUP_SIZES["2xl"].badge,
    gap: 4,
  },
}

export const tableRowSizeVariants = tv({
  slots: {
    base: "",
    image: "rounded",
    text: "",
    badge: "",
    verifiedIcon: "shrink-0",
  },
  variants: {
    size: {
      xs: {
        base: "h-6 text-xs",
        image: "min-h-5 min-w-5",
        text: "text-xs",
        badge: avatarBadgeVariants({ size: "xs" }),
        verifiedIcon: "size-3.5",
      },
      sm: {
        base: "h-8 text-sm",
        image: "min-h-6 min-w-6",
        text: "text-sm",
        badge: avatarBadgeVariants({ size: "sm" }),
        verifiedIcon: "size-3.5",
      },
      md: {
        base: "h-12 text-sm",
        image: "min-h-8 min-w-8",
        text: "text-sm",
        badge: avatarBadgeVariants({ size: "sm" }),
        verifiedIcon: "size-3.5",
      },
      lg: {
        base: "h-[60px] text-sm",
        image: "min-h-10 min-w-10",
        text: "text-sm",
        badge: avatarBadgeVariants({ size: "sm" }),
        verifiedIcon: "size-4",
      },
      xl: {
        base: "h-[68px] text-md",
        image: "min-h-12 min-w-12",
        text: "text-md",
        badge: avatarBadgeVariants({ size: "md" }),
        verifiedIcon: "size-6",
      },
      "2xl": {
        base: "h-[76px] text-md",
        image: "min-h-14 min-w-14",
        text: "text-md",
        badge: avatarBadgeVariants({ size: "md" }),
        verifiedIcon: "size-6",
      },
    },
  },
})
